module.exports = __webpack_public_path__ + "static/media/midframe2.5756ca14.jpg";